module.exports = __webpack_public_path__ + "img/Blog-Image.dfe774be.png";